module.exports = __webpack_public_path__ + "static/media/Icon awesome-angle-right.654da81a.svg";